import { Crown } from 'lucide-react';
import { getEntitlements } from '@/utils/entitlements';

export function PlanBadge({ userProfile, dark = false }: { userProfile: any; dark?: boolean }) {
  if (!userProfile) return null;

  // Platform, white-label, and facility users operate on per-seat enterprise access.
  // They should never display a consumer B2C badge.
  const isPlatformUser =
    userProfile?.facility_type === 'platform' ||
    Boolean(userProfile?.facility_id) ||
    Boolean(userProfile?.facility_org_type) ||
    Boolean(userProfile?.facility_branding);

  if (isPlatformUser) {
    return null;
  }

  const { plan, isPaid } = getEntitlements(userProfile);

  // Do not show a "Free" badge — per-seat and standard users should not be labeled "Free"
  if (!isPaid) {
    return null;
  }

  const name =
    plan === 'edu_elite'
      ? 'Elite Academy'
      : plan === 'edu_bundle'
        ? 'Complete Bundle'
        : plan === 'homeschool_single'
          ? 'Standard Education'
          : 'Premium Member';

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: '3px 10px',
        borderRadius: 100,
        fontSize: 11,
        fontWeight: 800,
        background: 'rgba(201,168,76,0.15)',
        color: '#C9A84C',
        border: '1px solid rgba(201,168,76,0.3)',
        whiteSpace: 'nowrap',
      }}
    >
      <Crown size={10} /> {name}
    </span>
  );
}
